import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import React from "react";
import { useNavigate } from "react-router-dom";
import ButtonBar from "../../components/Buttons/ButtonBar";
import NewButton from "../../components/Buttons/NewButton";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import { useGetTimeslotsQuery } from "../../services/appln";
import { convertTimestamp, doesPermissionExist } from "../util";
import DeleteTimeslot from "./DeleteTimeslot";
import EditTimeslot from "./EditTimeslot";
import NewTimeslot from "./NewTimeslot";

interface Timeslot {
  key: string;
  name: string;
  desc: string;
  startTime: string;
  endTime: string;
  assessmentCount: number;
}

interface Data {
  serialNo: string;
  bandobastName: string;
  rowData: Timeslot[];
  columnData: ColumnsType<Timeslot>;
}

export default function ListTimeslots(props: any) {
  const [data, setData] = React.useState<Data>({
    serialNo: "",
    bandobastName: "",
    rowData: [],
    columnData: [],
  });

  const navigate = useNavigate();

  const bandobastContext = JSON.parse(localStorage.getItem("bandobast")!);

  const [newDialogOpen, setNewDialogOpen] = React.useState(false);

  const timeslotsQueryResponse = useGetTimeslotsQuery(props.bandobastId);

  React.useEffect(() => {
    if (timeslotsQueryResponse.isSuccess) {
      const rowData = timeslotsQueryResponse.data.data.map<Timeslot>(
        (e: any) => {
          return {
            key: e.id,
            name: e.name,
            desc: e.desc,
            startTime: e.startTime,
            endTime: e.endTime,
            personnelAssessmentCount: e.personnelAssessmentCount,
            resourceAssessmentCount: e.resourceAssessmentCount,
          };
        },
      );

      const columns: ColumnsType<Timeslot> = [
        {
          title: strings.name,
          dataIndex: "name",
          key: "name",
          width: 5,
        },
        {
          title: strings.description,
          dataIndex: "desc",
          key: "desc",
          width: 15,
        },
        {
          title: strings.startTime,
          dataIndex: "startTime",
          key: "startTime",
          width: 5,
          render: (text, record, index) => convertTimestamp(text),
        },
        {
          title: strings.endTime,
          dataIndex: "endTime",
          key: "endTime",
          width: 5,
          render: (text, record, index) => convertTimestamp(text),
        },
        {
          title: "",
          dataIndex: "edit",
          key: "edit",
          width: 2,
          render: (text, record, index) =>
            doesPermissionExist("update-timeslot") && (
              <EditTimeslot
                bandobastId={props.bandobastId!}
                timeslotId={record.key}
                initialValues={record}
              />
            ),
        },
        {
          title: "",
          dataIndex: "delete",
          key: "delete",
          width: 2,
          render: (text, record, index) =>
            doesPermissionExist("delete-timeslot") && (
              <DeleteTimeslot
                bandobastId={props.bandobastId!}
                timeslotId={record.key}
              />
            ),
        },
      ];

      setData({
        serialNo: timeslotsQueryResponse.data.serialNo,
        bandobastName: timeslotsQueryResponse.data.name,
        rowData: rowData,
        columnData: columns,
      });
    }
  }, [timeslotsQueryResponse]);

  console.log("ListTimeslots, data:", data);

  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      {(timeslotsQueryResponse.isLoading ||
        timeslotsQueryResponse.isFetching) && <ProgressIndicator />}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ButtonBar>
            <NewButton
              onClickHandler={() => {
                setNewDialogOpen(true);
              }}
            />
            <NewTimeslot
              bandobastId={props.bandobastId!}
              onSubmitHandler={(newObj: any) => {
                console.log("onSubmitHandler, newObj:", newObj);
                setNewDialogOpen(false);
              }}
              onCancelHandler={() => {
                console.log("onCancelHandler");
                setNewDialogOpen(false);
              }}
              state={newDialogOpen}
            />
          </ButtonBar>
        </Grid>
        <Grid item xs={12}>
          <Table
            virtual
            scroll={{ y: 600 }}
            columns={data.columnData}
            dataSource={data.rowData}
            pagination={false}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
          >
            {strings.back}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
